import axios from "axios";
import { apiUrl } from "@utils/configEnv";
import { LOGIN, MAINTENANCE } from "@routes/routes";
import { API_BASE_URL } from "@config/app";

axios.defaults.baseURL = API_BASE_URL;
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;
axios.interceptors.response.use(
  response => response,
  async error => {
    const status = error?.response?.status;
    const originalRequest = error.config;

    if (status === 401) {
      window.location.href = LOGIN;
    }

    if (status === 419 && !originalRequest._retry) {
      originalRequest._retry = true;
      await axios.get(`${apiUrl()}/csrf-cookie`);
      return axios(originalRequest);
    }

    if (status === 503 && window.location.pathname !== MAINTENANCE) {
      window.location.href = MAINTENANCE;
    }

    return Promise.reject(error);
  },
);

export default axios;
